import { render, staticRenderFns } from "./MenuItemAutoComplete.vue?vue&type=template&id=4bebf49a&class=menu-item-cost&"
import script from "./MenuItemAutoComplete.vue?vue&type=script&lang=js&"
export * from "./MenuItemAutoComplete.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemAutoComplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports